'use client';

import type { Point, Side } from './types';

/**
 * @description Returns two points that are padded from the exit point in the direction of the exit side
 */
export function getPaddedExitPoints(
  { x, y }: Point,
  exitSide: Side,
  padding = DEFAULT_PADDING
): Point[] {
  switch (exitSide) {
    case 'top':
      return [
        { x: x - padding, y: y + padding },
        { x: x + padding, y: y + padding },
      ];
    case 'bottom':
      return [
        { x: x - padding, y: y - padding },
        { x: x + padding, y: y - padding },
      ];
    case 'left':
      return [
        { x: x + padding, y: y - padding },
        { x: x + padding, y: y + padding },
      ];
    case 'right':
      return [
        { x: x - padding, y: y - padding },
        { x: x - padding, y: y + padding },
      ];
    default:
      throw new Error('unreachable');
  }
}

export const DEFAULT_PADDING = 5;
